import { Component, OnInit, Input, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { StateService, AuthService, AuctionService, MyAuctionLotService, AuctionLotService, CustomerService, SystemParametersService } from '../../../services';
import { AuctionLotImageModel, BidRequestModel } from '../../../models';
import { FormFunctions } from '../../../functions';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalViewAuctionImagesComponent } from '../../modals';
import { BidIncrementService } from 'src/app/services/bid-increment.service';
import { fadeAnimation } from 'src/app/shared/animations';
import { AuctionLotItemComponent } from 'src/app/components';

@Component({
    selector: 'auction-search-card',
    styleUrls: ['./auction-search-card.component.scss'],
    templateUrl: './auction-search-card.component.html',
    animations: [fadeAnimation],
})
export class AuctionSearchCardComponent extends AuctionLotItemComponent implements OnInit, OnDestroy {
    IsMarkBidClicked: boolean = false;
    IsPlaceBidClicked: boolean = false;
    IsConfirmBidClicked: boolean = false;

    IsIncreaseBidClicked: boolean = false;
    IsFavouriteItemClicked: boolean = false;
    prevState: boolean = false;

    @ViewChild("newBid") newBid: ElementRef;
    //@ViewChild("confirmBid") confirmBid: ElementRef;

    constructor(
        public router: Router,
        public activatedRoute: ActivatedRoute,
        public stateService: StateService,
        public modalService: NgbModal,
        public authService: AuthService,
        public formFunctions: FormFunctions,
        public auctionService: AuctionService,
        public auctionLotService: AuctionLotService,
        public myAuctionLotService: MyAuctionLotService,
        public bidIncrementService: BidIncrementService,
        public customerService: CustomerService,
        public systemParametersService: SystemParametersService,
    ) {
        super(router, activatedRoute, stateService, modalService, authService, formFunctions, auctionService, auctionLotService, myAuctionLotService, bidIncrementService, customerService, systemParametersService)
        var me = this;
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    MarkBid() {
        let me = this;
        if (me.stateService.userModel) {
            me.IsMarkBidClicked = true;
            setTimeout(() => { me.newBid?.nativeElement?.select(); }, 0); // focus on the text box
        }
    }

    PlaceBid() {
        let me = this;
        if (me.NewBidIsValid) {
            me.IsPlaceBidClicked = true;
            me.processing = true;
            me.bidIncrementService.AdjustToIncrement(me.newBidAmt).subscribe(data => {
                // console.log('AdjustToIncrement', me.newBidAmt, data.DecimalValue);
                let oldVal = me.newBidAmt;
                me.newBidAmt = data.DecimalValue;
                // Only set 'old' value if it's actually different and has been adjusted
                me.oldBidAmt = null;
                if (me.newBidAmt != oldVal) {
                    me.oldBidAmt = oldVal;
                }
                me.processing = false;
            });
        }
    }

    /**
     * Reset the UI status after a bid update is received
     */
    ResetStatus() {
        super.ResetStatus();
        let me = this;
        // me.IsIncreaseBidClicked = false;
        // me.IsMarkBidClicked = false;
        // me.IsPlaceBidClicked = false;
        // me.IsConfirmBidClicked = false;
        //me.IsFavouriteItemClicked = false;
        // me.prevState = false;
    }

    ResetItemStatus() {
        let me = this;
        me.IsIncreaseBidClicked = false;
        me.IsMarkBidClicked = false;
        me.IsPlaceBidClicked = false;
        me.IsConfirmBidClicked = false;
        me.IsFavouriteItemClicked = false;
        me.prevState = false;
    }

    ConfirmBid(lot) {
        let me = this;
        me.processing = true;
        me.IsConfirmBidClicked = true;
        me.oldBidAmt = null;
        me.errorMessage = null;

        me.ResetItemStatus();

        me.auctionLotService.SubmitBids([<BidRequestModel>{
            AuctionLotId: lot.Id,
            BidAmount: me.newBidAmt
        },]).subscribe((data) => {
            // console.log(data); // We don't need to use this data - the bidMade event will update the UI appropriately
            var errors = data?.filter(x => x.Message);
            if (errors?.length > 0) {
                console.warn('Error during bids', errors);
                me.ResetStatus();
                let error = errors[0];
                me.errorMessage = error.Message;
                //alert('Bid not accepted');
            }
            me.myAuctionLotService.UpdateList();
            me.processing = false;
        });

        me.newBidAmt = null;
    }

    IncreaseBid() {
        let me = this;
        me.IsIncreaseBidClicked = true;
    }

    GoBackToPrevState() {
        let me = this;
        if (me.IsConfirmBidClicked) {
            me.IsConfirmBidClicked = false;
        }
        else if (me.IsPlaceBidClicked) {
            me.IsPlaceBidClicked = false;
            me.oldBidAmt = null;
            //me.newBidAmt = null;
        }
        else if (me.IsMarkBidClicked) {
            me.IsMarkBidClicked = false;
            me.newBidAmt = null;
        }
    }
}
